import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "overflow-hidden bg-white border border-gray-100 rounded-lg shadow-sm" };
const _hoisted_2 = { class: "flex items-center justify-between px-5 py-4" };
const _hoisted_3 = { class: "flex items-center min-w-0 gap-4" };
const _hoisted_4 = { class: "min-w-0" };
const _hoisted_5 = { class: "text-xs text-gray-400" };
const _hoisted_6 = { class: "flex items-center flex-shrink-0 gap-3 ml-4" };
const _hoisted_7 = { class: "flex flex-wrap items-center gap-6 px-5 py-3" };
const _hoisted_8 = { class: "flex flex-col gap-0.5" };
const _hoisted_9 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_10 = { class: "flex flex-col gap-0.5" };
const _hoisted_11 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_12 = { class: "flex flex-col gap-0.5" };
const _hoisted_13 = { class: "text-xs font-medium text-gray-400" };
const _hoisted_14 = { class: "flex items-center gap-2" };
const _hoisted_15 = ["disabled"];
import { computed } from "vue";
import { IconMessageCircle, IconCalendarEvent, IconBus } from "@tabler/icons-vue";
import { reservationService } from "../services";
import { formatServiceDatetime } from "@/domains/shared/utils/date-utils";
import { useConversationCreation } from "@/domains/conversation";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BookingCard',
    props: {
        booking: {}
    },
    emits: ["view-details"],
    setup(__props) {
        const props = __props;
        const { t, locale } = useI18n();
        const { findOrRedirect, isCreating: isCreatingConversation } = useConversationCreation();
        const effectiveState = computed(() => reservationService.getDisplayStatus(props.booking));
        const isCancelled = computed(() => effectiveState.value === "CANCELLED");
        const serviceName = computed(() => props.booking.serviceName || "—");
        const bookingReference = computed(() => reservationService.formatBookingReference(props.booking.id));
        const serviceIconComponent = computed(() => reservationService.getServiceIcon(props.booking.serviceTypeCode) === "IconBus"
            ? IconBus
            : IconCalendarEvent);
        const stateLabel = computed(() => {
            locale.value;
            return reservationService.getState(effectiveState.value);
        });
        const stateBadgeClass = computed(() => reservationService.getStateBadgeClass(effectiveState.value));
        const stateDotClass = computed(() => reservationService.getStateDotClass(effectiveState.value));
        // Detail values use $text-secondary (gray-500) for cancelled, $text-primary (gray-900) otherwise
        const detailValueClass = computed(() => isCancelled.value ? "text-gray-500" : "text-gray-900");
        const formattedDate = computed(() => formatServiceDatetime(props.booking.startsAt));
        const clientFullName = computed(() => props.booking.customerName || "—");
        // Only itinerary-sourced bookings have an itineraryId to key a conversation
        // off of; DIRECT/EXTERNAL bookings have no post-booking chat entry point yet
        // (findOrRedirect would otherwise fall back to a PRE_BOOKING inquiry, which
        // mislabels an already-confirmed booking).
        const showChatButton = computed(() => !isCancelled.value && props.booking.itineraryId != null);
        const chatButtonLabel = computed(() => {
            locale.value;
            return props.booking.fulfillmentStatus === "ACKNOWLEDGED"
                ? t("reservations.actions.view_chat")
                : t("reservations.actions.start_chat");
        });
        async function handleOpenChat() {
            if (props.booking.itineraryId == null)
                return;
            await findOrRedirect({
                serviceId: String(props.booking.serviceId),
                itineraryId: String(props.booking.itineraryId),
                bookingId: String(props.booking.id),
                slotId: String(props.booking.serviceSlotId),
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full", isCancelled.value ? 'bg-gray-100' : 'bg-blue-50'])
                        }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(serviceIconComponent.value), {
                                class: _normalizeClass(["w-5 h-5", isCancelled.value ? 'text-gray-400' : 'text-blue-600'])
                            }, null, 8, ["class"]))
                        ], 2),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("p", {
                                class: _normalizeClass(["text-sm font-semibold truncate", isCancelled.value ? 'text-gray-500' : 'text-gray-900'])
                            }, _toDisplayString(serviceName.value), 3),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(bookingReference.value), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                            class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold", stateBadgeClass.value])
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["w-1.5 h-1.5 rounded-full flex-shrink-0", stateDotClass.value])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(stateLabel.value), 1)
                        ], 2)
                    ])
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1)),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("reservations.auto.fecha_del_servicio")), 1),
                        _createElementVNode("span", {
                            class: _normalizeClass(["text-sm font-medium", detailValueClass.value])
                        }, _toDisplayString(formattedDate.value), 3)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("reservations.auto.huesped")), 1),
                        _createElementVNode("span", {
                            class: _normalizeClass(["text-sm font-medium", detailValueClass.value])
                        }, _toDisplayString(clientFullName.value), 3)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("reservations.auto.pasajeros")), 1),
                        _createElementVNode("span", {
                            class: _normalizeClass(["text-sm font-medium", detailValueClass.value])
                        }, _toDisplayString(__props.booking.partySize) + " adultos", 3)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        (showChatButton.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                disabled: _unref(isCreatingConversation),
                                class: "inline-flex items-center gap-1.5 h-[34px] px-3.5 rounded-md text-xs font-semibold bg-eorange-50 text-eorange-600 hover:bg-eorange-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors border border-eorange-200",
                                onClick: handleOpenChat
                            }, [
                                _createVNode(_unref(IconMessageCircle), { class: "w-3.5 h-3.5" }),
                                _createTextVNode(" " + _toDisplayString(_unref(isCreatingConversation) ? "Opening..." : chatButtonLabel.value), 1)
                            ], 8, _hoisted_15))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center h-[34px] px-3.5 rounded-md text-xs font-semibold border border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('view-details', __props.booking)))
                        }, _toDisplayString(_ctx.$t("reservations.auto.ver_detalles")), 1)
                    ])
                ])
            ]));
        };
    }
});
